const projectData = [
  {
    id: 1,
    type: 'Web design',
    status: 'Completed',
    color: 'success',
    title: 'Landing page Design',
    text:
      'If several languages coalesce, the grammar of the resulting language is more regular.',
    images: [
      require('@assets/images/users/avatar-2.jpg'),
      require('@assets/images/users/avatar-3.jpg'),
    ],
    date: '15 Dec',
    bars: 56,
    comment: 224,
    progress: 100,
  },
  {
    id: 2,
    type: 'Android',
    status: 'Pending',
    color: 'warning',
    title: 'App Design and Develop',
    text:
      'To achieve this, it would be necessary to have uniform grammar and more common words.',
    images: [
      require('@assets/images/users/avatar-4.jpg'),
      require('@assets/images/users/avatar-5.jpg'),
    ],
    date: '28 Nov',
    bars: 62,
    comment: 196,
    progress: 72,
  },
  {
    id: 3,
    type: 'Web design',
    status: 'Completed',
    color: 'success',
    title: 'New Admin Design',
    text:
      'To an English person, it will seem like simplified english, as a skeptical Cambridge.',
    images: [require('@assets/images/users/avatar-7.jpg')],
    date: '19 Nov',
    bars: 69,
    comment: 201,
    progress: 100,
  },
  {
    id: 4,
    type: 'Android',
    status: 'Pending',
    color: 'warning',
    title: 'Custom Software Development',
    text:
      'Their separate existence is a myth. For science, music, sport, etc uses the vocabulary',
    images: [
      require('@assets/images/users/avatar-6.jpg'),
      require('@assets/images/users/avatar-7.jpg'),
    ],
    date: '02 Nov',
    bars: 72,
    comment: 184,
    progress: 60,
  },
  {
    id: 5,
    type: 'Web design',
    status: 'Completed',
    color: 'success',
    title: 'Brand logo design',
    text:
      'Everyone realizes why a new common language refuse to pay expensive translators.',
    images: [require('@assets/images/users/avatar-8.jpg')],
    date: '15 Dec',
    bars: 56,
    comment: 224,
    progress: 100,
  },
  {
    id: 6,
    type: 'Android',
    status: 'Completed',
    color: 'success',
    title: 'Landing page Design',
    text:
      'If several languages coalesce, the grammar of the resulting language is more regular.',
    images: [
      require('@assets/images/users/avatar-9.jpg'),
      require('@assets/images/users/avatar-10.jpg'),
    ],
    date: '11 Oct',
    bars: 71,
    comment: 163,
    progress: 100,
  },
]

export { projectData }
